import React from 'react';
import JournalMonoHtmlView from './JournalHtml';
import JournalMonoReactView from './Journal';
const JournalMonoView = (props)=>{
    if (props.isHtml) {
        return /*#__PURE__*/ React.createElement(JournalMonoHtmlView, props);
    }
    return /*#__PURE__*/ React.createElement(JournalMonoReactView, props);
};
JournalMonoView.displayName = 'JournalMonoView';
export default JournalMonoView;
